'use client';

import React, { useState } from 'react';
import { TransformComponent, TransformWrapper } from 'react-zoom-pan-pinch';
import { cn } from '@/utils/cn';
import { getImageUrl } from '@/utils/string';
import { imageTypes } from '@/constants/types';
import Icon from './Icon';
import ImageComponentV2 from './Image/ImageComponentV2';

function Zoom({ images = [] }) {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isDisableZoomInButton, setIsDisableZoomInButton] = useState(false);
  const [isDisableZoomOutButton, setIsDisableZoomOutButton] = useState(true);

  if (
    (Array.isArray(images?.length) && images?.length === 0) ||
    !Array.isArray(images)
  ) {
    return null;
  }

  const nextSlide = () => {
    const maxIndex = images?.length ? images.length - 1 : 0;
    setCurrentIndex((prevIndex) =>
      prevIndex === maxIndex ? 0 : prevIndex + 1,
    );
  };

  const prevSlide = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? images.length - 1 : prevIndex - 1,
    );
  };

  const handleZoom = ({ state }) => {
    const currentScale = state.scale;

    setIsDisableZoomInButton(currentScale >= 5);
    setIsDisableZoomOutButton(currentScale <= 1);
  };

  const handleTransformed = ({ state }) => {
    const currentScale = state.scale;

    setIsDisableZoomInButton(currentScale >= 5);
    setIsDisableZoomOutButton(currentScale <= 1);
  };

  return (
    <TransformWrapper
      initialScale={1}
      initialPositionX={0}
      initialPositionY={0}
      onZoom={handleZoom}
      minScale={1}
      maxScale={5}
      onTransformed={handleTransformed}
    >
      {({ zoomIn, zoomOut }) => (
        <>
          <div className="tools flex items-center justify-end gap-[4px] relative">
            <div
              className={cn(
                'bg-white size-[32px] lg:size-[48px] flex justify-center items-center p-8 border border-supreme-grey rounded-[4px]',
                {
                  '!border-supreme-grey': isDisableZoomOutButton,
                },
              )}
            >
              <button
                type="button"
                onClick={() => zoomOut()}
                disabled={isDisableZoomOutButton}
              >
                <Icon
                  type="zoom-out"
                  color={isDisableZoomOutButton ? '#BEC7D5' : '#49525E'}
                  className="size-[20px] lg:size-[32px]"
                />
              </button>
            </div>
            <div
              className={cn(
                'bg-white size-[32px] lg:size-[48px] flex justify-center items-center p-8 border border-supreme-grey rounded-[4px]',
                {
                  '!border-supreme-grey': isDisableZoomOutButton,
                },
              )}
            >
              <button
                type="button"
                onClick={() => zoomIn()}
                disabled={isDisableZoomInButton}
              >
                <Icon
                  type="zoom-in"
                  color={isDisableZoomInButton ? '#BEC7D5' : '#49525E'}
                  className="size-[20px] lg:size-[32px]"
                />
              </button>
            </div>
          </div>
          <div className="bg-white flex justify-center w-full mb-16">
            <TransformComponent>
              <div className="flex justify-center transition-transform duration-300 max-h-[386px] md:max-h-[723px] h-[60vh]">
                <ImageComponentV2
                  src={
                    images[currentIndex]?.image
                      ? getImageUrl(images[currentIndex]?.image)
                      : null
                  }
                  alt={images?.name?.en}
                  className="object-contain object-center"
                  width={730}
                  height={400}
                  loading="lazy"
                  type={imageTypes.tall}
                />
              </div>
            </TransformComponent>
          </div>
          <div className="flex items-center justify-between gap-[5px]">
            <button
              type="button"
              className={cn(
                'size-[32px] lg:size-[48px] bg-white flex justify-center items-center p-8 border border-senate rounded-[4px] cursor-pointer',
                {
                  'opacity-40 cursor-not-allowed': currentIndex === 0,
                },
              )}
              onClick={prevSlide}
              disabled={currentIndex === 0} // current 0 === 2
            >
              <Icon
                type="angle-down"
                color="#565F6B"
                className="size-[20px] lg:size-[32px] rotate-90"
              />
            </button>
            <button
              type="button"
              className={cn(
                'size-[32px] lg:size-[48px] bg-white flex justify-center items-center p-8 border border-senate rounded-[4px] cursor-pointer',
                {
                  'opacity-40 cursor-not-allowed':
                    currentIndex === images.length - 1,
                },
              )}
              onClick={nextSlide}
              disabled={currentIndex === images.length - 1} // current 2 === 2
            >
              <Icon
                type="angle-down"
                color="#565F6B"
                className="size-[20px] lg:size-[32px] -rotate-90"
              />
            </button>
          </div>
        </>
      )}
    </TransformWrapper>
  );
}

export default Zoom;
